"use client";

import {
  handleDefaltWhatsappMessage,
  phoneFormatter,
  removeNonNumericAndSpaces,
} from "@/components/package-components/utils";
import { Footer1Props } from "../../../props";
import styles from "./footer-store-address-01.module.scss";
import { useCallback } from "react";

export default function FooterStoreAddressVariant01(props: Footer1Props) {
  const showPhone = props.showPhone?.value ?? true;
  const showWhatsapp = props.showWhatsapp?.value ?? true;

  const phoneStore1 = String(
    props.phoneStore1?.value ?? props.phoneStore1 ?? ""
  );
  const whatsappStore1 = String(
    props.whatsappPhone1?.value ?? props.whatsappPhone1 ?? ""
  );
  const phoneStore2 = String(
    props.phoneStore2?.value ?? props.phoneStore2 ?? ""
  );
  const whatsappStore2 = String(
    props.whatsappPhone2?.value ?? props.whatsappPhone2 ?? ""
  );

  const handleOpenWhatsapp = useCallback((whatsapp: string) => {
    if (!whatsapp) return;
    const cleanNumber = removeNonNumericAndSpaces(whatsapp);
    const defaultMsg = handleDefaltWhatsappMessage();
    const url = `https://wa.me/55${cleanNumber}?text=${encodeURIComponent(
      defaultMsg + window.location.href
    )}`;
    window.open(url, "_blank");
  }, []);

  return (
    <div className={`${styles.container} container-${props.id}`}>
      {/* Loja 1 */}
      <div
        className={`${styles["container__address"]} container__address-${props.id}`}
      >
        {props.nameStore1?.value && (
          <p
            className={`${styles["container__address__label"]} container__address__label-${props.id}`}
          >
            <span
              className={`${styles["container__address__label__decorator"]} container__address__label__decorator-${props.id}`}
            />
            {props.nameStore1.value}
          </p>
        )}

        {/* Telefone Loja 1 */}
        {phoneStore1 && showPhone && (
          <a
            href={`tel:${removeNonNumericAndSpaces(phoneStore1)}`}
            className={`${styles["container__address__item"]} container__address__item-${props.id}`}
            data-umami-event="Ligar Agora"
            aria-label="Ligar Agora"
          >
            {phoneFormatter(phoneStore1)}
          </a>
        )}

        {/* WhatsApp Loja 1 */}
        {whatsappStore1 && showWhatsapp && (
          <button
            type="button"
            className={`${styles["container__address__item"]} container__address__item-${props.id} gtm_event_whatsapp`}
            data-umami-event="Falar no Whatsapp"
            onClick={() => handleOpenWhatsapp(whatsappStore1)}
            aria-label="Chamar no Whatsapp Agora"
          >
            {phoneFormatter(whatsappStore1)} (WhatsApp)
          </button>
        )}

        {/* Endereço Loja 1 */}
        {(props.addressStore1?.value ?? props.addressStore1) && (
          <a
            href={String(props.linkGPS?.value ?? props.linkGPS)}
            target="_blank"
            rel="noreferrer"
            className={`${styles["container__address__item"]} container__address__item-${props.id}`}
            aria-label="Ver endereço no mapa"
          >
            <p>{String(props.addressStore1?.value ?? props.addressStore1)}</p>
          </a>
        )}
      </div>

      {/* Loja 2 */}
      <div
        className={`${styles["container__address"]} container__address-${props.id}`}
      >
        {props.nameStore2?.value && (
          <p
            className={`${styles["container__address__label"]} container__address__label-${props.id}`}
          >
            <span
              className={`${styles["container__address__label__decorator"]} container__address__label__decorator-${props.id}`}
            />
            {props.nameStore2.value}
          </p>
        )}

        {/* Telefone Loja 2 */}
        {phoneStore2 && showPhone && (
          <a
            href={`tel:${removeNonNumericAndSpaces(phoneStore2)}`}
            className={`${styles["container__address__item"]} container__address__item-${props.id}`}
            data-umami-event="Ligar Agora"
            aria-label="Ligar Agora"
          >
            {phoneFormatter(phoneStore2)}
          </a>
        )}

        {/* WhatsApp Loja 2 */}
        {whatsappStore2 && showWhatsapp && (
          <button
            type="button"
            className={`${styles["container__address__item"]} container__address__item-${props.id} gtm_event_whatsapp`}
            data-umami-event="Falar no Whatsapp"
            onClick={() => handleOpenWhatsapp(whatsappStore2)}
          >
            {phoneFormatter(whatsappStore2)} (WhatsApp)
          </button>
        )}

        {/* Endereço Loja 2 */}
        {(props.addressStore2?.value ?? props.addressStore2) && (
          <a
            href={String(props.linkGPS2?.value ?? props.linkGPS2)}
            target="_blank"
            rel="noreferrer"
            className={`${styles["container__address__item"]} container__address__item-${props.id}`}
            aria-label="Ver endereço no mapa"
          >
            <p>{String(props.addressStore2?.value ?? props.addressStore2)}</p>
          </a>
        )}
      </div>
    </div>
  );
}
